import type {
  AddUserRequest,
  AdminMember,
  ApiResponse,
  PaginatedResponse,
  PaginationParams,
  SendMoneyRequest,
  User,
  UserSearchParams,
  UserSearchResult,
  UserTransaction
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class UserService {
  async addUser(data: AddUserRequest): Promise<ApiResponse> {
    return apiManager.post('/api/v1/admin/users', data);
  }

  async getAdminMembers(): Promise<ApiResponse<AdminMember[]>> {
    return apiManager.get<AdminMember[]>('/api/v1/admin/members');
  }

  async removeAdminMember(id: string): Promise<ApiResponse> {
    return apiManager.delete(`/api/v1/admin/members/${id}`);
  }

  async resetAdminPassword(id: string): Promise<ApiResponse> {
    return apiManager.post(`/api/v1/admin/members/${id}/reset-password`);
  }

  async resetAdminPin(id: string): Promise<ApiResponse> {
    return apiManager.post(`/api/v1/admin/members/${id}/reset-pin`);
  }

  async getUsers(params?: PaginationParams): Promise<ApiResponse<{ users: User[] } & PaginatedResponse<User>>> {
    return apiManager.get('/api/v1/admin/users/list', params);
  }

  async searchUsers(params: UserSearchParams): Promise<ApiResponse<UserSearchResult[]>> {
    return apiManager.get<UserSearchResult[]>('/api/v1/admin/users/search', params);
  }

  async blockUser(id: string): Promise<ApiResponse> {
    return apiManager.post(`/api/v1/admin/users/${id}/block`);
  }

  async getUserTransactions(
    id: string,
    params?: PaginationParams
  ): Promise<ApiResponse<{ transactions: UserTransaction[] } & PaginatedResponse<UserTransaction>>> {
    return apiManager.get(`/api/v1/admin/users/${id}/transactions`, params);
  }

  async sendMoney(data: SendMoneyRequest): Promise<ApiResponse> {
    return apiManager.post('/api/v1/admin/users/send-money', data);
  }
}

export const userService = new UserService();